import cn from 'classnames'
import * as React from 'preact/compat'

import { sgVersion, showModal } from '#js/common/helpers'

import SVG from '#components/SVG'
import RatingSpinner from '#components/RatingSpinner'
import type { SearchItemProps } from '#components/Search/SearchPanel'

import commonCss from '#css/common.pcss.json'
import buttonsCss from '#css/v9/buttons.pcss.json'
import css from '#css/v9/cards/game-compilation-card.pcss.json'

// noinspection ES6UnusedImports

export default ({ item, isLoggedIn }: SearchItemProps) => {
  const report = React.useCallback(() => {
    import(`/dist/js/components/ClaimModal.js?${sgVersion()}`)
      .then(({ default: ClaimModal }) => {
        showModal(ClaimModal, {
          // @ts-ignore
          targetType: 'compilation',
          targetId: item.id
        })
      })
  }, [])

  const gameImages = []

  for (let i = 0; i < 5; i++) {
    let order = 5 - i

    const imgProps = {
      className: css['game-image'],
      style: `--inverse-order: ${order}`
    }

    if (!item.gameImages[i] || item.gameImages[i] === '') {
      gameImages.push(<div {...imgProps}/>)
      continue
    }
    gameImages.push(<img
      alt=""
      src={item.gameImages[i]}
      {...imgProps}
    />)
  }

  let addToFavouritesOptions: Record<string, string> = {
    'data-plugins': 'auth'
  }

  if (isLoggedIn) {
    addToFavouritesOptions = {
      'data-plugins': 'add-favourite',
      'data-add-favourite-type': 'compilation',
      'data-add-favourite-id': `${item.id}`,
      'data-active-class': css['bookmark--active']
    }
  }

  const userImageProps: React.ImgHTMLAttributes = {}

  if (item.user.inTeam) {
    userImageProps.title = 'В команде StopGame'
  } else if (item.user.isBlogWinner) {
    userImageProps.title = 'Автор блога недели'
  }

  return <article className={css['card']}>
    <a href={item.url} className={css['game-images']}>
      {gameImages}
    </a>
    <div className={css['status-info']}>
      <div className={css['status-info--left']}>
        <span>
          <SVG i='sg-new/gamepad' adaptive/>
          {item.games_count}
        </span>
        <button
          type="button"
          className={cn(buttonsCss['button'], buttonsCss['button--icon'])}
          style='--button-padding: 0; --button-width: auto'
          onClick={report}
        >
          <SVG i="sg-new/warning" adaptive/>
        </button>
        <button
          type="button"
          className={cn(buttonsCss['button'], buttonsCss['button--icon'], css['bookmark'], {
            [css['bookmark--active']]: item.isFavourite
          })}
          {...addToFavouritesOptions}
        >
          <SVG i="sg-new/bookmark" adaptive/>
        </button>
      </div>
      <RatingSpinner
        targetType="compilation"
        targetId={item.id}
        value={item.rating}
        isGuest={!isLoggedIn}
        canVote={item.canVote}
        vote={item.userVote}
      />
    </div>
    <div
      data-user-info={true}
      className={cn({
        [commonCss['user-info']]: true,
        [commonCss['user-info--in-team']]: item.user.inTeam,
        [commonCss['user-info--kosar']]: item.user.isBlogWinner,
        [css['user-info']]: true,
        [commonCss['user-info--24']]: true
      })}
    >
      <img
        alt=""
        src={item.user.avatar}
        className={commonCss['user-info__avatar']}
        data-user-info-image={true}
        {...userImageProps}
      />
      <span class={commonCss['user-info__name']} data-user-info-name={true}>
        {item.user.name}
      </span>
    </div>
    <a href={item.url} className={css['title']} dangerouslySetInnerHTML={{ __html: item.title }}/>
    <span className={css['content']} dangerouslySetInnerHTML={{ __html: item.description }}/>
  </article>
}
